import { SelectListItemRenderer } from '@acies/core';
import { Label } from '@acies/ui';

export default class ImportComponentCO2LinkListItemRenderer extends SelectListItemRenderer<string> {
	#nameLabel!: Label;
	public constructor() {
		super();
		this.width = 'fill';
		this.height = 32;
		this.alignment = 'left';
		this.paddingHorizontal = 16;
		this.gapHorizontal = 16;
		this.enabled = false;
	}

	protected override initialize(): void {
		super.initialize();
		this.#createChildren();
	}

	protected override itemChanged(): void {
		super.itemChanged();
		if (this.item) {
			this.nameLabel.text = this.item;
		}
	}

	private get nameLabel(): Label {
		if (!this.#nameLabel) {
			this.#nameLabel = new Label();
			this.#nameLabel.width = 'fill';
		}
		return this.#nameLabel;
	}

	#createChildren(): void {
		this.addComponent(this.nameLabel);
	}
}
customElements.define('ac-import-component-co2link-item-renderer', ImportComponentCO2LinkListItemRenderer);
